import {
	EXISTING_CARD_PAYMENT_ERRORS,
	PAYMENT_SUMMARY_ERRORS,
	CARD_PAYMENT_FROM_ERRORS,
} from '@acorn-portal/shared/src/utils/constants/ErrorMessages';
import { NAME_REGEX, SORT_CODE_REGEX } from '@acorn-portal/shared/src/utils/constants/Regex';
import * as Yup from 'yup';

const baseFinanceSchema = {
	affordable: Yup.string()
		.required(PAYMENT_SUMMARY_ERRORS.premiumFinance)
		.trim()
		.matches(/yes/, PAYMENT_SUMMARY_ERRORS.affordableLendingNo),
	accept_dd_terms: Yup.boolean().oneOf([true], PAYMENT_SUMMARY_ERRORS.detailsCorrect),
};

const checkoutSchema = (
	requiresPayment: boolean,
	isFinance: boolean,
	existingCard: boolean,
	validatePremium: boolean,
) =>
	Yup.object().shape({
		...(isFinance &&
			(validatePremium
				? {
						premiumConfirm: Yup.string()
							.required(PAYMENT_SUMMARY_ERRORS.premiumFinance)
							.trim()
							.matches(/yes/, PAYMENT_SUMMARY_ERRORS.premiumFinanceNo),
						...baseFinanceSchema,
					}
				: baseFinanceSchema)),
		...(existingCard && {
			id: Yup.string().required(EXISTING_CARD_PAYMENT_ERRORS.id),
		}),
		...(requiresPayment &&
			!existingCard && {
				billingDetails: Yup.string().required(CARD_PAYMENT_FROM_ERRORS.billingDetails),
				cardholderFirstName: Yup.mixed().when('billingDetails', {
					is: 'no',
					then: () =>
						Yup.string()
							.matches(NAME_REGEX, CARD_PAYMENT_FROM_ERRORS.cardholderNameSpecialChar)
							.required(CARD_PAYMENT_FROM_ERRORS.cardholderFirstNameRequired),
					otherwise: (schema) => schema.notRequired(),
				}),
				cardholderLastName: Yup.mixed().when('billingDetails', {
					is: 'no',
					then: () =>
						Yup.string()
							.matches(NAME_REGEX, CARD_PAYMENT_FROM_ERRORS.cardholderNameSpecialChar)
							.required(CARD_PAYMENT_FROM_ERRORS.cardholderLastNameRequired),
					otherwise: (schema) => schema.notRequired(),
				}),
				cardholderEmail: Yup.mixed().when('billingDetails', {
					is: 'no',
					then: () =>
						Yup.string().email('Please enter a valid email address').required('Email address is a required field'),
					otherwise: (schema) => schema.notRequired(),
				}),
				address: Yup.object({
					line1: Yup.string().required('First line of billing address is required'),
					postcode: Yup.string().required('Postcode is required'),
				}),
			}),
		account_number: Yup.mixed().when('new_direct_debit', {
			is: true,
			then: () =>
				Yup.string().min(8, PAYMENT_SUMMARY_ERRORS.accountNumber).required(PAYMENT_SUMMARY_ERRORS.accountNumber),
			otherwise: (schema) => schema.notRequired(),
		}),
		sort_code: Yup.mixed().when('new_direct_debit', {
			is: true,
			then: () =>
				Yup.string()
					.matches(SORT_CODE_REGEX, PAYMENT_SUMMARY_ERRORS.sortCodeValid)
					.required(PAYMENT_SUMMARY_ERRORS.sortCode),
			otherwise: (schema) => schema.notRequired(),
		}),
		is_account_holder: Yup.mixed().when('new_direct_debit', {
			is: true,
			then: () =>
				Yup.string()
					.required(PAYMENT_SUMMARY_ERRORS.isAccountHolder)
					.trim()
					.matches(/yes/, PAYMENT_SUMMARY_ERRORS.isAccountHolderNo),
			otherwise: (schema) => schema.notRequired(),
		}),
		is_only_signatory_required: Yup.mixed().when('new_direct_debit', {
			is: true,
			then: () =>
				Yup.string()
					.required(PAYMENT_SUMMARY_ERRORS.isOnlySignatoryRequired)
					.trim()
					.matches(/yes/, PAYMENT_SUMMARY_ERRORS.isOnlySignatoryRequiredNo),
			otherwise: (schema) => schema.notRequired(),
		}),
	});

export default checkoutSchema;
